<template>
  <v-dialog
    persistent
    v-model="quitDialog"
    :disabled="!isPermission || isDisabled"
    width="400"
  >
    <v-btn dark color="#FFE3E0" class="quitBtn UXbtn" slot="activator" :disabled="!isPermission" >
      <i class="UXicon-fin"></i>
      相談終了
    </v-btn>
    <div class="dialogCon">
      <div>相談を終了しますか？</div>
      <div v-if="!disableSurveySettings" class="sendSurveyCheck">
        <v-checkbox
          v-model="survey.sendSurvey"
          label="アンケートリンクを送信する"
          class="UXcheckbox gray"
          hide-details
        ></v-checkbox>
      </div>
      <div class="btn">
        <div>
          <v-btn outline round large class="UXbtn" :disabled="loading" @click="closeQuitDialog">いいえ</v-btn>
          <v-btn round dark large color="#ff8c8c" class="UXbtn" :loading="loading" :disabled="loading" @click="quitChatRoom()">はい</v-btn>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import eventBus from '@/event_bus'
import eventType from '@/components/operation/enums/eventType'

export default {
  name: 'quit_dialog',
  props: ['chatRoomId', 'isDisabled', 'survey', 'isVersion2', 'agentId', 'isPermission', 'isMailInput', 'isLineChat'],
  computed: {
    disableSurveySettings () {
      if (this.survey) {
        if (this.isVersion2) {
          return (this.survey.disableSurveySetting || !this.survey.useSurvey || this.survey.surveyList.length === 0) || this.survey.sendTiming !== 'AGENT_END_COUNSELING'
        } else {
          return this.survey.disableSurveySetting || !this.survey.useSurvey || this.survey.surveyList.length === 0
        }
      } else {
        return true
      }
    }
  },
  data () {
    return {
      quitDialog: false,
      loading: false,
      maxSurveyTitleLength: 20
    }
  },
  methods: {
    closeQuitDialog () {
      this.quitDialog = false
    },
    quitChatRoom () {
      if (this.isLineChat) {
        this.$alertMsg('相談終了案内メッセージを送信できません。</br>詳しい事項はLINEで確認が可能です。', '使用可能なメッセージを全て使用されました。')
        this.closeQuitDialog()
        return false
      }
      if (this.loading) return
      this.sendChatRoomClose()
    },
    sendChatRoomClose () {
      this.loading = true
      this.$http.post('/api/chat/sendChatRoomClose', {
        chatRoomId: this.chatRoomId,
        sendSurvey: this.isMailInput ? false : this.survey.sendSurvey && this.survey.surveyList.length > 0
      }).then(res => {
        if (res.data.code === 0) {
          this.closeQuitDialog()
          eventBus.$emit('customer-history-initialize')
          eventBus.$emit(eventType.TAKE_OVER_MESSAGE_CLEAR)
        } else {
          this.$alertMsg(res.data.message)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/quit_dialog.vue